import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {
  APP_DATE_FORMAT, APP_TIME_FORMAT, AppointmentCorrespondence,
  CommonUtility, DataService, DateUtility, FileResponse,
  ServerConstantsService,
  AgGridUtility,
  PRINT_BTN
} from '../shared';
import { NotificationsService } from 'angular2-notifications';
import { ReferenceTableService } from '../reference-table.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Correspondence } from '../shared/model/Correspondence';
import { GridOptions } from 'ag-grid';



@Component({
  selector: 'app-correspondence',
  templateUrl: './correspondence.component.html',
  styleUrls: ['./correspondence.component.scss']
})

/**
 *
 *    1. If task doesn't exist show error message 'No tasks found'
 *    2. If the task exist but appointment doesn't exist show 'Manual Correspondence'
 *    3. If the task exist and the appointment exist check that wpDockInfo exist otherway
 *       don't how anything.
 *
 *
 * */



export class CorrespondenceComponent implements OnInit {

  appCorrespondenceExist: Boolean = false;
  serverConstants: any;
  userActionNotificationsMap: any;
  modalReference: any;
  closeResult: string;
  APP_DATE_FORMAT = APP_DATE_FORMAT;
  APP_TIME_FORMAT = APP_TIME_FORMAT;
  fileResponse: FileResponse;
  correspondeceService: boolean;
  triggerFound: boolean;
  sharedData: any;
  columnDefs: any;
  context: any;
  gridOptions: GridOptions;
  gridApi : any;
  firstTime: Boolean = true;

  wpPersonId;
  appointmentCorrespondenceRequest: AppointmentCorrespondence = new AppointmentCorrespondence();
  appointmentCorrespondenceResult: AppointmentCorrespondence = new AppointmentCorrespondence();
  newData: AppointmentCorrespondence = new AppointmentCorrespondence();

  @ViewChild('header') header: ElementRef;
  tabToNextCell: any;

  constructor(
    private http: HttpClient,
    private data: ReferenceTableService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private dateUtil: DateUtility,
    private commonUtil: CommonUtility,
    private router: Router,
    public dataService: DataService,
    private agGridUtility: AgGridUtility,
  ) {
    this.serverConstants = serverConstantsService.getConstants();
    this.gridOptions = <GridOptions>{};
    if (this.dataService.getSharedDataObject().get('CSNTS') === undefined) {
      this.router.navigate(['/task']);
    }
  }


  ngOnInit() {
    this.sharedData = this.dataService.getSharedDataObject();

    this.appointmentCorrespondenceResult.responseArray = [];
    this.parseRefTableData();
    this.wpPersonId = this.sharedData.get('wpPersonId');

    if (this.wpPersonId !== undefined && this.wpPersonId > 0) {
      this.appointmentCorrespondenceRequest.requestId = this.wpPersonId;
      this.findCorrespondence();
    }
    this.getColumnDefinitions();
  }

  /******************************* Ag- Grid **********************************/

  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: 'Document ID',
        field: 'wpDocTriggerInfo.id'
      },
      {
        headerName: 'Notice Type',
        field: 'wpDocTriggerInfo.wpDocInfo.description',
        cellStyle: { 'white-space': 'normal' },
      },
      {
        headerName: 'Printed Date',
        field: 'wpDocTriggerInfo.generatedDt',
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.filterDates,
        },
      },
      {
        headerName: 'Printed By',
        field: 'wpDocTriggerInfo.generatedBy',
      },
      {
        headerName: 'Action',
        field: '',
        cellRenderer: this.getEditButton,
      }
    ];

    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if (nextCell == null || nextCell.column.colDef.headerName === 'Action') {
        return;
      } else {
        return nextCell;
      }
    };

    this.context = {
      component: this
    };
  }



  filterDates(filterLocalDateAtMidnight, cellValue) {
    if (!cellValue) {
      return;
    }
    const dateParts = cellValue.split('/');
    const day = Number(dateParts[2]);
    const month = Number(dateParts[1]) - 1;
    const year = Number(dateParts[0]);
    const cellDate = new Date(year, month, day);
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    } else {
      return 0;
    }
  }

  getEditButton(params) {
    const that = params.context.component;
    // Edit Button
    const element = document.createElement('a');
    const image = PRINT_BTN;
    element.innerHTML = image;

    element.addEventListener('click', () => {
      that.action(params.data);
    });
    element.addEventListener('keydown', (event) => {
      if(event.keyCode == 13 || event.keyCode == 32) {
        that.action(params.data);
      }
    });
    element.setAttribute("tabindex", "0");
    return element;
  }

  onGridReady(params) {
    this.gridOptions.api = params.api;
    this.gridApi = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onResize(event) {
    if (window.screen.width >= window.innerWidth) {
      this.gridOptions.columnDefs = this.columnDefs;
    } else {
      this.gridOptions.api.sizeColumnsToFit();
    }
  }

  /********************************** Get Data ******************************************/
  parseRefTableData() {
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(
      this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));
  }

  convertCode(myMap, code) {
    if (myMap !== undefined) {
      return myMap.get(code);
    }
  }

  /****************************** Supporting functions ******************************/


  findCorrespondence() {
    this.appointmentCorrespondenceRequest.requestId = this.wpPersonId;
    this.http.post<any>(this.serverConstants.CORRESPONDENCE_API_URL + '/correspondence/find',
      this.appointmentCorrespondenceRequest).subscribe(
        (val: any) => {
          this.newData = val;
          let requestUserNames: Array<any> = [];
          for (let i=0; i < val.responseArray.length; i++) {
            requestUserNames.push(val.responseArray[i].wpDocTriggerInfo.generatedBy);
          }
          this.http.post<any>(this.serverConstants.SERVER_API_URL + '/user/usernames', requestUserNames).subscribe((data) => {

            let keys = Object.keys(data);
            for (let i = 0; i < keys.length; i++) {
              for (let j = 0; j < this.newData.responseArray.length; j++) {
                if (this.newData.responseArray[j].wpDocTriggerInfo.generatedBy !== null 
                  && this.newData.responseArray[j].wpDocTriggerInfo.generatedBy === keys[i]) {
                  this.newData.responseArray[j].wpDocTriggerInfo.generatedBy = data[keys[i]];
                }
              }
            }
            this.appointmentCorrespondenceResult = this.newData;
          })
        },
        response => {
          this.notificationService.error('Correspondence', this.userActionNotificationsMap.ERROR);
        },
        () => {
        });
  }

  action(correspondence: Correspondence) {
    if (correspondence.fileResponse === null) {
      this.actionGenerate(correspondence);
    } else {
      this.actionDownload(correspondence.fileResponse);
    }
  }

  actionGenerate(correspondence: Correspondence) {
    let correspondenceResult;
    this.appointmentCorrespondenceRequest.requestId = correspondence.wpDocTriggerInfo.id;


    this.http.post<any>(this.serverConstants.CORRESPONDENCE_API_URL + '/correspondence/generate',
      this.appointmentCorrespondenceRequest).subscribe(
        (val: any) => {
          correspondenceResult = val;
        },
        response => {
          this.notificationService.error('Correspondence', this.userActionNotificationsMap.ERROR);
        },
        () => {
          if (correspondenceResult.fileResponse != null) {
            this.actionDownload(correspondenceResult.fileResponse);
            this.createAlert();
          }
          this.findCorrespondence();
        });
  }

  actionDownload(file) {
    let arr = file.fileDownloadUri.split("/api");
    file.fileDownloadUri = this.serverConstants.CORRESPONDENCE_API_URL + arr[1];
    this.http.get<any>(file.fileDownloadUri, {
      responseType: 'blob' as 'json'
    }).map(res => {
        return {
          filename: file.fileName,
          data: res
        };
      }).subscribe(
        (res: any) => {
          if(window.navigator && window.navigator.msSaveOrOpenBlob){
            window.navigator.msSaveOrOpenBlob(res.data);
          }
          else{
            const url = window.URL.createObjectURL(res.data);
            window.open(url);
          }
        }, response => { 

        });
  }

  focusSummary(e: KeyboardEvent) {
    this.firstTime = false;
    this.addEventListenerToSearch(event);
  }


  addEventListenerToSearch(event){
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if(event.keyCode !== tabKeyCode) {
      return;
    }

    if(this.appointmentCorrespondenceResult.responseArray.length === 0){
      return;
    }

    if(event.shiftKey){
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }

  setDisplayedRowAtIndex() {
    // get the first row
    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  onPaginationChanged(event) {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  gridClick() {
    this.firstTime = false;
  }

  focusing(event) {
    if (!event.shiftKey && event.keyCode === 9) {
      event.preventDefault();
      setTimeout(() => this.header.nativeElement.focus(), 0);
      this.header.nativeElement.click();
    }
  }
  createAlert(){
    let requestArray=[];
    let request = {
      createdBy: sessionStorage.getItem("FirstName"),
      description:"A new document has posted to your account",
      personId:Number(this.sharedData.get('wpPersonId'))
    }
    requestArray.push(request);
  this.http.post(this.serverConstants.CITIZEN_API_URL+"/alerts/save",requestArray).subscribe((data)=>{
    if(data["message"]=="success"){
      this.notificationService.success('Correspondence', "Alert Created for Citizen");
    }
    else{
      this.notificationService.error('Correspondence', "Unable to create alert for citizen");
    }
  },error=>{
    this.notificationService.error('Correspondence', "Unable to create alert for citizen");
  })
}
}



// WEBPACK FOOTER //
// ./src/app/correspondence/correspondence.component.ts